<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="images/logo.png" alt="">
      </div>
      <div class="name-box">韦氏幼儿智力量表第四版中文版统计分析系统</div>
      <topMenu :num="1"></topMenu>
    </div>
    <div class="main-body">
      <div class="left">
        <div class="avt-bg">
          <img src="images/avt-icon.png" alt="">
        </div>
        <div class="zs-box">
          <div class="zs-box-left">
            <span>主试编号</span>
            <span>{{ certificate_no }}</span>
          </div>
          <div class="zs-box-right">
            <span>主试姓名</span>
            <span>{{ name }}</span>
          </div>
        </div>
        <div class="num-container">
          <div class="title"><span class="line"></span>可用记分服务数：</div>
          <div class="flex">
            <div class="flex flex-1 fs">
              <a-progress type="circle" :percent="100" :width="100" :stroke-color="{
        '0%': '#ce7344',
        '100%': '#a5336f',
      }">
                <template #format="percent">
                  <div style="display: flex;flex-direction: column;align-items: center">
                    <div style="font-size: 12px; color: #86898B">2:6-3:11岁</div>
                    <div style="font-size: 12px;color: #86898B;margin-top: 5px"><span
                        style="color: #832C75;font-weight: bold;">{{ examinerNum.wisc_child_num }}</span>份
                    </div>
                  </div>
                </template>
              </a-progress>
            </div>
            <div class="flex flex-1 fe">
              <a-progress type="circle" :percent="100" :width="100" :stroke-color="{
        '0%': '#ce7344',
        '100%': '#a5336f',
      }">
                <template #format="percent">
                  <div style="display: flex;flex-direction: column;align-items: center">
                    <div style="font-size: 12px; color: #86898B">4:0-6:11岁</div>
                    <div style="font-size: 12px;color: #86898B;margin-top: 5px"><span
                        style="color: #832C75;font-weight: bold;">{{ examinerNum.wisc_youth_num }}</span>份
                    </div>
                  </div>
                </template>
              </a-progress>
            </div>
          </div>
        </div>
        <div class="num-container" style="margin-top: 20px;border-bottom: none">
          <div class="title"><span class="line"></span>已用记分服务数：</div>
          <div class="flex">
            <div class="flex flex-1 fs">
              <a-progress type="circle" :percent="examinerNum.wisc_child_num / usedRecord.used_wisc_child_num" :width="100" :stroke-color="{
        '0%': '#ce7344',
        '100%': '#a5336f',
      }">
                <template #format="percent">
                  <div style="display: flex;flex-direction: column;align-items: center">
                    <div style="font-size: 12px; color: #86898B">2:6-3:11岁</div>
                    <div style="font-size: 12px;color: #86898B;margin-top: 5px"><span style="color: #832C75;font-weight: bold;">{{ usedRecord.used_wisc_child_num }}</span>份</div>
                  </div>
                </template>
              </a-progress>
            </div>
            <div class="flex flex-1 fe">
              <a-progress type="circle" :percent="examinerNum.wisc_youth_num / usedRecord.used_wisc_youth_num" :width="100" :stroke-color="{
        '0%': '#ce7344',
        '100%': '#a5336f',
      }">
                <template #format="percent">
                  <div style="display: flex;flex-direction: column;align-items: center">
                    <div style="font-size: 12px; color: #86898B">4:0-6:11岁</div>
                    <div style="font-size: 12px;color: #86898B;margin-top: 5px"><span style="color: #832C75;font-weight: bold;">{{ usedRecord.used_wisc_youth_num }}</span>份</div>
                  </div>
                </template>
              </a-progress>
            </div>
          </div>
        </div>
        <div class="result-box">
          <span>报告结果： <span class="active">{{ totalNum }}</span> 份</span>
        </div>
        <div class="login-date">上次登录：{{ login_time }}</div>
      </div>
      <div class="right">
        <div class="content" style="margin: 0">
          <div class="header">
            <div class="title-box"><img src="images/input-header-icon.png" alt=""><span
                class="name">最新提交记分数据列表</span><span class="name"
                                                    style="font-size: 13px;margin-left: 20px">{{ currentTime }}</span>
            </div>
          </div>
          <div class="body">
            <div class="search-box">
              <div class="search-form">
                <a-form-model layout="inline">
                  <a-form-model-item label="诊疗卡号">
                    <a-input allowClear placeholder="" class="cu-input input-cuw" v-model="page.archives_num"/>
                  </a-form-model-item>
                  <a-form-model-item label="儿童姓名">
                    <a-input allowClear placeholder="" class="cu-input input-cuw" v-model="page.name"/>
                  </a-form-model-item>
                  <a-form-model-item label="报告编号">
                    <a-input allowClear placeholder="" class="cu-input input-cuw" v-model="page.scoring_num"/>
                  </a-form-model-item>

                  <a-form-model-item label="测试类型">
                    <a-select allowClear placeholder="请选择" v-model="page.edition" style="width: 150px">
                      <a-select-option value="1">2:6-3:1</a-select-option>
                      <a-select-option value="2">4:0-6:11</a-select-option>
                      <a-select-option value="3">7:0-18:11</a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item>
                    <a-range-picker style="width:220px" allowClear @change="changeRangeDate" format="YYYY-MM-DD"/>
                  </a-form-model-item>
                  <a-form-model-item>
                    <span class="search-btn" @click="getList()"><img src="images/search.png" alt=""></span>
                  </a-form-model-item>
                </a-form-model>
              </div>
              <div class="search-actions">
                <a-button class="export-btn" :disabled="page.totalRow === 0 && !exportRunning" @click="startExport">
                  <a-icon :type="exportRunning ? 'loading' : 'download'" />
                  {{ exportRunning ? '查看进度' : '导出Excel' }}
                </a-button>
                <a-button class="add-data-btn" type="primary" @click="goBaseData">
                  <a-icon type="plus" />添加数据
                </a-button>
              </div>
            </div>
            <div class="list-box">
              <a-table :columns="columns" :data-source="list" :pagination="false">
                <template slot="edition" slot-scope="text, record">
                  <span v-if="text == 1">2:6-3:11</span>
                  <span v-if="text == 2">4:0-6:11</span>
                  <span v-if="text == 3">7:0-18:11</span>
                </template>
                <template slot="action" slot-scope="text, record" style="display: flex;align-items: center">
                  <a class="op-box" target="_blank" :href="'http://' + record.down_pdf_url" download="pdf"><img src="static/download.png" style="width: 20px;height: 20px"
                                            alt=""><span>下载</span></a>
                  <span class="de-line"></span>
                  <span class="op-box" @click.stop="goEdit(record, 'index')"><img src="static/edit.png"
                                                                    style="width: 14px;height: 14px"
                                                                    alt=""><span>编辑</span></span>
                  <span class="de-line"></span>
                  <span class="op-box" @click.stop="openDetail(record)"><img src="static/eye.png"
                                                                                  style="width: 16px;height: 16px"
                                                                                  alt=""><span>详情</span></span>
                </template>
              </a-table>
            </div>
            <div class="content-page cu-page" style="display: flex;align-items: center;justify-content: flex-end;margin-top: 10px">
              <a-pagination :hideOnSinglePage="true" v-model="page.start" :page-size.sync="page.pageSize"
                            :total="page.totalRow" show-less-items @change="changePage"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <detail :item="item" :detailVisible="detailVisible" @detailCancel="detailCancel"/>
    <a-modal
      :visible="exportVisible"
      :width="520"
      :footer="null"
      :mask-closable="false"
      wrap-class-name="export-progress-modal"
      centered
      @cancel="exportVisible = false"
    >
      <div class="export-dialog">
        <div class="export-heading">
          <div class="export-status-icon" :class="exportStatusClass">
            <a-icon :type="exportStatusIcon" :spin="exportRunning" />
          </div>
          <div>
            <h3>{{ exportStatusTitle }}</h3>
            <p>{{ exportStage }}</p>
          </div>
        </div>

        <a-progress
          :percent="exportPercent"
          :status="exportProgressStatus"
          :stroke-color="exportProgressColor"
          :show-info="true"
        />

        <div class="export-metrics">
          <div>
            <span>处理进度</span>
            <strong>{{ exportProcessedText }}</strong>
          </div>
          <div>
            <span>导出范围</span>
            <strong>当前筛选全部报告</strong>
          </div>
          <div>
            <span>工作表</span>
            <strong>韦氏幼儿测试记录</strong>
          </div>
        </div>

        <div v-if="exportError" class="export-error">
          <a-icon type="exclamation-circle" />{{ exportError }}
        </div>

        <div class="export-dialog-actions">
          <a-button v-if="exportRunning" @click="exportVisible = false">后台继续</a-button>
          <template v-else-if="exportStatus === 'success'">
            <a-button @click="exportVisible = false">完成</a-button>
            <a-button type="primary" :loading="exportDownloading" @click="downloadExport">
              <a-icon v-if="!exportDownloading" type="download" />再次下载
            </a-button>
          </template>
          <template v-else-if="exportStatus === 'failed'">
            <a-button @click="exportVisible = false">关闭</a-button>
            <a-button type="primary" @click="startExport(true)">
              <a-icon type="reload" />重新导出
            </a-button>
          </template>
        </div>
      </div>
    </a-modal>
    <footer-bottom></footer-bottom>
    <bind-list @changeBindList="changeBindList" :id="id" :type="'select'" name="" gender="" born_time="" edition=""
               scoring_type="" :is-visible="bindListVisible"></bind-list>

  </div>
</template>

<script>
import * as Api from './api';
import {GetInfo} from '../../commonApi';
import {message} from "ant-design-vue";
import moment from 'moment';

export default {
  data() {
    return {
      base_url: process.env.VUE_APP_API,
      login_code: window.localStorage.getItem('login_code'),
      labelCol: {span: 8, style: {color: '#7E8589', fontWeight: '500'}},
      wrapperCol: {span: 14},
      columns: [
        {
          title: '诊疗卡号',
          dataIndex: 'archives_num',
          key: 'archives_num',
          scopedSlots: {customRender: 'archives_num'},
        },
        {
          title: '报告编号',
          dataIndex: 'scoring_num',
          key: 'scoring_num',
          scopedSlots: {customRender: 'scoring_num'},
        },
        {
          title: '儿童姓名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {customRender: 'name'},
        },
        {
          title: '测试类型',
          dataIndex: 'edition',
          key: 'edition',
          scopedSlots: {customRender: 'edition'},
        },
        {
          title: '测试时间',
          dataIndex: 'test_date',
          key: 'test_date',
          scopedSlots: {customRender: 'test_date'},
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          scopedSlots: {customRender: 'create_time'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          scopedSlots: {customRender: 'action'},
          width: 200
        },
      ],
      page: {
        start: 1,
        limit: 10,
        totalRow: 0,
        pageSize: 0,
        name: '',
        archives_num: '',
        scoring_num: '',
        edition: undefined,
        isToday: false,
        startTime: '',
        endTime: ''
      },
      list: [],
      name: '',
      certificate_no: '',
      examinerNum: {
        "wisc_youth_num": 0,
        "wisc_child_num": 0
      },
      usedRecord: {
        "used_wisc_child_num": 0,
        "used_wisc_youth_num": 0
      },
      login_time: '',
      totalNum: '',
      currentTime: '',
      bindListVisible: false,
      id: '',
      detailVisible: false,
      item: {},
      exportVisible: false,
      exportTaskId: '',
      exportStatus: 'idle',
      exportPercent: 0,
      exportProcessed: 0,
      exportTotal: 0,
      exportStage: '准备创建导出任务',
      exportFileName: '',
      exportError: '',
      exportDownloading: false,
      exportDownloaded: false,
      exportTimer: null,
      exportPollFailures: 0
    };
  },
  computed: {
    exportRunning() {
      return this.exportStatus === 'queued' || this.exportStatus === 'running';
    },
    exportStatusTitle() {
      if (this.exportStatus === 'success') return '导出完成';
      if (this.exportStatus === 'failed') return '导出未完成';
      return '正在导出报告数据';
    },
    exportStatusIcon() {
      if (this.exportStatus === 'success') return 'check';
      if (this.exportStatus === 'failed') return 'close';
      return 'loading';
    },
    exportStatusClass() {
      if (this.exportStatus === 'success') return 'success';
      if (this.exportStatus === 'failed') return 'failed';
      return 'running';
    },
    exportProgressStatus() {
      if (this.exportStatus === 'success') return 'success';
      if (this.exportStatus === 'failed') return 'exception';
      return 'active';
    },
    exportProgressColor() {
      return this.exportStatus === 'success' ? '#43897f' : '#832c75';
    },
    exportProcessedText() {
      if (!this.exportTotal) return this.exportRunning ? '正在统计数据' : '0 份';
      return `${this.exportProcessed} / ${this.exportTotal} 份`;
    }
  },
  mounted() {
    this.getList();
    this.getInfo();

    let d = moment(new Date(window.localStorage.getItem('login_time'))).format('YYYY-MM-DD HH:mm:ss')
    let c = moment(Date.now()).format('ll')
    this.login_time = d;
    this.currentTime = c + '报表查询';
  },
  beforeDestroy() {
    this.clearExportTimer();
  },
  methods: {
    goBaseData() {
      this.$router.push({path: '/base-info'});
    },
    goSelectAge() {
      this.$router.push({path: '/select-age'})
    },
    async getList() {
      const res = await Api.List(this.page);
      if (res && res.code == 0) {
        this.list = res.page.list;
        this.page.totalRow = res.page.totalRow;
        this.page.pageSize = res.page.pageSize;
      }
    },
    async getInfo() {
      const res = await GetInfo({});
      if (res && res.code == 0) {
        this.name = res.chiefExaminer.name;
        this.certificate_no = res.chiefExaminer.certificate_no;
        this.examinerNum = res.examinerNum;
        this.usedRecord = res.usedRecord;
        this.totalNum = res.usedRecord.totalWisc;
      }
    },
    changePage(e) {
      this.page.start = e;
      this.getList();
    },
    openBindList(id) {
      this.bindListVisible = true;
      this.id = id;
    },
    changeBindList(e) {
      if (e.type == 'cancel') {
        this.bindListVisible = false;
      } else if (e.type == 'select') {
        this.bind(e.data.id);
      }
    },
    async bind(id) {
      const res = await Api.Binding({binding_id: id, id: this.id});
      if (res && res.code == 0) {
        message.success({content: res.message});
        this.bindListVisible = false;
        this.getList();
      }
    },
    goEdit(record, srouce) {
      if (record.is_edit != 1) {
        message.error({content: '报告只能编辑一次'});
        return;
      }
      if (record.edition == 1) {
        this.$router.push({path: '/children', query: {id: record.id, source: srouce}})
      } else if (record.edition == 2) {
        this.$router.push({path: '/youth', query: {id: record.id, source: srouce}})
      } else if (record.edition == 3) {
        this.$router.push({path: '/juvenile', query: {id: record.id, source: srouce}})
      }
    },
    openDetail(item) {
        console.log(item);
      this.item = item;
      this.detailVisible = true;
    },
    detailCancel() {
      this.detailVisible = false;
    },
    changeRangeDate(e, s) {
      if (s) {
        this.page.startTime = s[0];
        this.page.endTime = s[1];
      } else {
        this.page.startTime = '';
        this.page.endTime = '';
      }
    },
    exportParams() {
      return {
        archives_num: this.page.archives_num,
        name: this.page.name,
        scoring_num: this.page.scoring_num,
        edition: this.page.edition,
        startTime: this.page.startTime,
        endTime: this.page.endTime
      };
    },
    async startExport(force = false) {
      this.exportVisible = true;
      if (this.exportRunning && !force) return;
      this.clearExportTimer();
      this.exportStatus = 'queued';
      this.exportPercent = 0;
      this.exportProcessed = 0;
      this.exportTotal = 0;
      this.exportStage = '正在创建导出任务';
      this.exportError = '';
      this.exportDownloaded = false;
      this.exportPollFailures = 0;
      try {
        const res = await Api.CreateExport(this.exportParams());
        if (res && res.code == 0) {
          this.applyExportTask(res.task);
          this.scheduleExportProgress();
        }
      } catch (error) {
        this.exportStatus = 'failed';
        this.exportStage = '导出任务创建失败';
        this.exportError = (error && error.message) || '导出任务创建失败，请稍后重试';
      }
    },
    applyExportTask(task) {
      if (!task) return;
      this.exportTaskId = task.taskId || this.exportTaskId;
      this.exportStatus = task.status || this.exportStatus;
      this.exportPercent = Number(task.percent) || 0;
      this.exportProcessed = Number(task.processed) || 0;
      this.exportTotal = Number(task.total) || 0;
      this.exportStage = task.stage || this.exportStage;
      this.exportFileName = task.fileName || this.exportFileName;
      this.exportError = task.message || '';
    },
    scheduleExportProgress() {
      this.clearExportTimer();
      if (!this.exportRunning || !this.exportTaskId) return;
      this.exportTimer = window.setTimeout(() => this.fetchExportProgress(), 800);
    },
    async fetchExportProgress() {
      try {
        const res = await Api.ExportProgress({taskId: this.exportTaskId});
        if (res && res.code == 0) {
          this.exportPollFailures = 0;
          this.applyExportTask(res.task);
          if (this.exportStatus === 'success' && !this.exportDownloaded) {
            await this.downloadExport();
          }
        }
      } catch (error) {
        this.exportPollFailures += 1;
        if (this.exportPollFailures < 3) {
          this.exportStage = '连接短暂中断，正在重新获取进度';
        } else {
          this.exportStatus = 'failed';
          this.exportStage = '无法获取导出进度';
          this.exportError = (error && error.message) || '无法获取导出进度，请重新导出';
        }
      } finally {
        this.scheduleExportProgress();
      }
    },
    async downloadExport() {
      if (!this.exportTaskId || this.exportDownloading) return;
      this.exportDownloading = true;
      this.exportError = '';
      try {
        const data = await Api.ExportDownload({taskId: this.exportTaskId});
        if (data && data.type && data.type.indexOf('application/json') !== -1) {
          const errorText = await this.readBlobText(data);
          const errorData = JSON.parse(errorText || '{}');
          throw new Error(errorData.message || '导出文件下载失败');
        }
        const blob = data instanceof Blob ? data : new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.exportFileName || '韦氏幼儿测评报告.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        this.exportDownloaded = true;
        message.success({content: 'Excel导出完成'});
      } catch (error) {
        this.exportError = (error && error.message) || '文件下载失败，请点击再次下载';
      } finally {
        this.exportDownloading = false;
      }
    },
    readBlobText(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsText(blob, 'UTF-8');
      });
    },
    clearExportTimer() {
      if (this.exportTimer) {
        window.clearTimeout(this.exportTimer);
        this.exportTimer = null;
      }
    }
  }
};
</script>
<style>
.ant-table-thead > tr > th {
  color: #832C75 !important;
  border-top: 2px solid #832C75;
  border-bottom: none;
  background-color: #F2F3F5;
}

.ant-progress-success-bg, .ant-progress-bg {
  background-color: #832C75;
}

.op-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 13px;
  cursor: pointer;
}

a.op-item, a.op-item:link {
  color: #666666;
}
</style>
<style scoped>
.avt-bg {
  width: 100%;
  height: 100px;
  background-image: var(--wisc-image-index-left-avt);
  display: flex;
  justify-content: center;
  background-size: contain;
  position: relative;
}

.avt-bg img {
  width: 120px;
  position: absolute;
  top: 10px;
}

.zs-box {
  display: flex;
  border-bottom: 1px solid #F2F3F5;
  padding-bottom: 20px;
  margin-bottom: 20px;
  margin-top: 10px;
}

.zs-box .zs-box-left, .zs-box .zs-box-right {
  flex: 1;
}

.zs-box .zs-box-right {
  border-left: 1px solid #F2F3F5
}

.zs-box .zs-box-left span, .zs-box .zs-box-right span {
  font-size: 14px;
  font-weight: 500;
  color: #4A4E51;
  display: block;
  text-align: center;
  line-height: 24px;
}

.main-body {
  background-image: var(--wisc-image-maintain-bg);
  align-items: flex-start;
  justify-content: flex-start;
}

.left {
  width: 260px;
  background: #FFFFFF;
  box-shadow: 0px 8px 25px 0px rgba(242, 243, 245, 0.28);
  border-radius: 12px;
  padding: 20px;
  height: 100%;
  overflow-y: scroll;
}

.right {
  flex: 1;
  margin-left: 20px;
  height: 100%;
  overflow-y: scroll;
}

.search-box {
  display: flex;
}

.search-box .search-form {
  flex: 1;
}

.search-btn {
  background-color: #D08846 !important;
  padding: 0px 15px !important;
  display: inline-block;
  border-radius: 4px;
  cursor: pointer;
}

.search-btn img {
  width: 14px;
}

.search-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 250px;
}

.export-btn,
.add-data-btn {
  height: 38px;
  border-radius: 5px;
  padding: 0 16px;
}

.export-btn {
  border-color: #832c75;
  color: #832c75;
  background: #fff;
}

.export-btn:hover,
.export-btn:focus {
  border-color: #a54894;
  color: #a54894;
}

.add-data-btn {
  border-color: #832c75;
  background: #832c75;
}

.export-dialog {
  padding: 8px 4px 2px;
}

.export-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 26px;
}

.export-heading h3 {
  margin: 0;
  color: #27313a;
  font-size: 19px;
  font-weight: 600;
}

.export-heading p {
  margin: 5px 0 0;
  color: #7e8589;
  font-size: 13px;
}

.export-status-icon {
  width: 46px;
  height: 46px;
  display: grid;
  flex: 0 0 46px;
  place-items: center;
  border-radius: 50%;
  font-size: 20px;
}

.export-status-icon.running {
  color: #832c75;
  background: #f1e7f0;
}

.export-status-icon.success {
  color: #28685f;
  background: #e1eeeb;
}

.export-status-icon.failed {
  color: #a43c3c;
  background: #f5e5e5;
}

.export-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 22px;
  padding: 17px 0;
  border-top: 1px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
}

.export-metrics > div {
  min-width: 0;
  padding: 0 14px;
  border-right: 1px solid #e7eaec;
}

.export-metrics > div:first-child {
  padding-left: 0;
}

.export-metrics > div:last-child {
  padding-right: 0;
  border-right: 0;
}

.export-metrics span,
.export-metrics strong {
  display: block;
}

.export-metrics span {
  color: #92999e;
  font-size: 12px;
}

.export-metrics strong {
  margin-top: 7px;
  color: #39434a;
  font-size: 13px;
  font-weight: 600;
  line-height: 19px;
  overflow-wrap: anywhere;
}

.export-error {
  margin-top: 15px;
  padding: 10px 12px;
  border-left: 3px solid #c94a4a;
  color: #9b3535;
  background: #faf0f0;
  font-size: 13px;
}

.export-error .anticon {
  margin-right: 7px;
}

.export-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}

.input-cuw {
  width: 110px;
}

.list-box {
  margin-top: 40px;
}

.title {
  font-size: 14px;
  font-weight: 500;
  color: #4A4E51;
  margin-bottom: 15px;
}

.title .line {
  height: 10px;
  border-left: 3px solid #832C75;
  margin-right: 10px;
}

.num-container {
  border-bottom: 1px solid #F2F3F5;
  padding-bottom: 10px;
}

.num-box {
  margin-bottom: 10px;
  padding-left: 12px;
}

.num-box .name {
  font-size: 12px;
  font-weight: 500;
  color: #86898B;
}

.progress-box {
  display: flex;
}

.progress-box .progress {
  flex: 1;
}

.progress-box .text {
  width: 60px;
  display: flex;
  justify-content: flex-end;
}

.progress-box .text {
  font-size: 12px;
  font-weight: 500;
  color: #86898B;
}

.progress-box .text span.active {
  color: #832C75;
}

.result-box {
  background-color: #F2F3F5;
  font-size: 14px;
  font-weight: 600;
  color: #4A4E51;
  text-align: center;
  padding: 10px 0;
  border-radius: 8px;
}

.result-box .active {
  color: #832C75;
}

.login-date {
  font-size: 13px;
  font-weight: 500;
  color: #7E8589;
  margin-top: 15px;
}

.de-line {
  border-right: 1px solid #ddd;
  height: 4px;
  margin: 0 10px;
}

.op-box {
  cursor: pointer;
  color: #666666;
  font-size: 12px;
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.fs {
  justify-content: flex-start;
}
.fe {
  justify-content: flex-end;
}
</style>
